<template>
  <div class="widget-carousel-tabs">
    <ul class="nav nav-tabs widget-carousel-tabs__nav" role="tablist">
      <li class="nav-item">
        <button
            type="button"
            class="nav-link"
            :class="{ active: activeTab === 'general' }"
            @click="setTab('general')"
        >
          General
        </button>
      </li>

      <li class="nav-item">
        <button
            type="button"
            class="nav-link"
            :class="{ active: activeTab === 'text' }"
            @click="setTab('text')"
        >
          Texte
        </button>
      </li>

      <li class="nav-item">
        <button
            type="button"
            class="nav-link"
            :class="{ active: activeTab === 'products', disabled: isProductsTabDisabled }"
            :disabled="isProductsTabDisabled"
            @click="setTab('products')"
        >
          {{ productsTabLabel }}
          <span
              v-if="products.length"
              class="widget-carousel-tabs__count"
          >
            {{ products.length }}
          </span>
        </button>
      </li>
    </ul>

    <div class="widget-carousel-tabs__content mt-3">
      <WidgetCarouselGeneralSettings
          v-if="activeTab === 'general'"
          :form="form"
      />

      <WidgetCarouselTextSettings
          v-if="activeTab === 'text'"
          :form="form"
      />

      <WidgetCarouselProductsTab
          v-if="activeTab === 'products'"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WidgetCarouselGeneralSettings from "./WidgetCarouselGeneralSettings.vue";
import WidgetCarouselTextSettings from "./WidgetCarouselTextSettings.vue";
import WidgetCarouselProductsTab from "./WidgetCarouselProductsTab.vue";

const STORE_NAMESPACE = "widgetCarousel";

export default {
  name: "WidgetCarouselTabs",

  components: {
    WidgetCarouselGeneralSettings,
    WidgetCarouselTextSettings,
    WidgetCarouselProductsTab
  },

  computed: {
    ...mapGetters(STORE_NAMESPACE, [
      "activeTab",
      "products",
      "isProductsTabDisabled",
      "form"
    ]),

    productsTabLabel() {
      return this.form && this.form.type === "offers" ? "Offers" : "Products";
    }
  },

  methods: {
    setTab(tab) {
      this.$store.dispatch(`${STORE_NAMESPACE}/setActiveTab`, tab);
    }
  }
};
</script>

<style scoped>
.widget-carousel-tabs__nav .nav-link {
  font-weight: 600;
  font-size: 14px;
}

.widget-carousel-tabs__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 999px;
  background: #eef1f5;
  font-size: 11px;
  font-weight: 700;
}

.widget-carousel-tabs__nav .nav-link.active .widget-carousel-tabs__count {
  background: rgba(255, 255, 255, 0.25);
}
</style>